import React from 'react'

const ManagePreferredPortPairsDialogContext = React.createContext()

export default ManagePreferredPortPairsDialogContext
